module.exports = __webpack_public_path__ + "img/female_vampire_mobile.4b5fe0a3.jpg";